import {resolveRoute} from '@computerrock/formation-router';
import routePaths from '../routePaths';

const goToParentRoute = ({currentPath, history, pathParams = {}, toParams = {}}) => {
    let path;
    let queryParams;

    switch (currentPath) {
        case routePaths.INVOICES:
        case routePaths.INVOICE_OVERVIEW: {
            path = routePaths.SERVICE_CASES_OVERVIEW;
            break;
        }

        case routePaths.SERVICE_CASES_OVERVIEW:
        case routePaths.SERVICE_CASE: {
            path = window.sessionStorage.getItem('serviceCaseOriginRoute') || routePaths.DASHBOARD;
            queryParams = window.sessionStorage.getItem('serviceCaseOriginQueryParams') || '';
            break;
        }

        case routePaths.MEMBER: {
            path = routePaths.DASHBOARD;
            break;
        }

        default:
            // no-op
    }

    if (!path) history.goBack();

    history.push(resolveRoute(path, pathParams, {
        ...toParams,
        ...(queryParams && {
            search: queryParams,
        }),
    }));
};

export default goToParentRoute;
